export default __webpack_public_path__ + "static/media/passkey-fingerprint-icon.5b1105a7.svg";